// NEXOVA theme provider for the admin/ops portal.
//
// The admin portal is DARK by default (operator console, dense, financial-grade).
// We wrap next-themes (already a dependency, also used by the sonner Toaster's
// useTheme()) with attribute="class" so the existing Tailwind v4 `.dark` token
// block applies, and defaultTheme="dark".
//
// enableSystem is OFF: the admin default is an explicit product decision (dark),
// not the OS preference. A theme toggle in the topbar flips dark<->light and the
// choice persists (next-themes localStorage) under storageKey "nx-admin-theme".

import { ThemeProvider as NextThemesProvider } from "next-themes";

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="dark"
      enableSystem={false}
      disableTransitionOnChange
      storageKey="nx-admin-theme"
    >
      {children}
    </NextThemesProvider>
  );
}
